import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import FeedbackDetailsUI from '../view/FeedbackDetailsUI';
import FeedbackStore from '../../store/FeedbackStore';
import NavigationStore from '../../../../navigation/store/NavigationStore';
import {Feedback} from '../../../../data/models/Feedback/Feedback';
import {APP_PERMISSIONS} from '../../../../data/permissions';
import ConfirmationModal from '../../../../uiToolkit/ConfirmationModal';
import ModalFade, {
  useModalFade,
} from '../../../Microreels/List/components/ModalFade';
import {feedbackText} from '../../feedbackText';

interface Props {
  feedbackStore?: FeedbackStore;
  navigationStore?: NavigationStore;
}

const FeedbackDetailsContainer = inject(
  'feedbackStore',
  'navigationStore',
)(
  observer(({feedbackStore, navigationStore}: Props) => {
    const [feedback, setFeedback] = useState<Feedback>();
    const [deleteShown, setDeleteShown] = useState(false);
    const {organizationId, feedbackId} = useParams();
    const navigate = useNavigate();

    const deleteFade = useModalFade(deleteShown);
    const listRoute = `/manage/${organizationId}/feedback_questions`;
    const canEdit = (navigationStore?.userPermissions || []).includes(
      APP_PERMISSIONS.ORG_CREATE_COURSES,
    );

    useEffect(() => {
      if (!organizationId || !feedbackId) return;
      let active = true;
      feedbackStore!.getFeedback(organizationId, feedbackId).then(found => {
        if (!active) return;
        if (!found) {
          navigate(listRoute, {replace: true});
          return;
        }
        setFeedback(found);
      });
      return () => {
        active = false;
      };
    }, [organizationId, feedbackId]);

    const onConfirmDelete = async () => {
      if (!organizationId || !feedback) return;
      const success = await feedbackStore!.deleteFeedback(
        organizationId,
        feedback.id,
      );
      setDeleteShown(false);
      if (success) {
        navigate(listRoute, {replace: true});
      }
    };

    return (
      <>
        <FeedbackDetailsUI
          feedback={feedback}
          canEdit={canEdit}
          isDeleting={!!feedbackStore?.isEditLoading}
          onBack={() => navigate(listRoute)}
          onDelete={() => setDeleteShown(true)}
        />
        {deleteFade.rendered && (
          <ModalFade closing={deleteFade.closing}>
            <ConfirmationModal
              shown
              title={feedbackText.deleteConfirm}
              acceptText={feedbackText.delete}
              onAccept={onConfirmDelete}
              onCancel={() => setDeleteShown(false)}
            />
          </ModalFade>
        )}
      </>
    );
  }),
);

export default FeedbackDetailsContainer;
